import Vue from 'vue'
import I18n from '@/i18n'
import messages from "@/util/messages";
import alert from '@/util/global-alert';
import { isNotEmpty } from '@/util/misc'
import { SETUP_FROM_DATA, SET_LOCALE, SIGN_OUT, LOAD_COUNTRIES, LAST_TOKEN_UPDATE, REMEMBER_ME, SET_EMAILS, DELETE_EMAIL, UPDATE_CLIENT_DATA } from '@/store/consts'
import { CODE_UNAUTHORIZED } from "@/util/errors";
import { URL_SIGN_OUT, URL_REFRESH_TOKEN, URL_SET_USER_LOCALE } from "@/globals";
import {handleUnauthorized} from "@/plugins/request";

const SESSION_UPDATE_INTERVAL_MS = 1 * 60 * 1000;

function initialState() {
    return {
        id: null,
        first_name: '',
        last_name: '',
        verified: false,
        suspended: true,
        created_on: 0,
        locale: localStorage._offline_locale ?? 'en',
        roles: [],
        emails: [],
        client: null,
        last_token_update: 0,
        // Устанавливается в форме регистрации. Если будет пройдена проверка, токен должен запоминаться в localStorage.
        sign_up_remember_me: false
    }
}

const user = {
    data() {
        return {
            timerId: null
        }
    },
    state: initialState,
    mutations: {
        simple_props(state, obj) {
            state.id = obj.id;
            state.first_name = obj.first_name;
            state.last_name = obj.last_name;
            state.verified = obj.verified;
            state.suspended = obj.suspended;
            state.created_on = obj.created_on;
            state.roles = obj.roles;
            state.settings = obj.settings;
            if (obj.emails) {
                state.emails = obj.emails;
                //state.verified = obj.verified && obj.emails.some( e => e.verified )
            } else {
                state.emails = []
            }
            // По заполнению формы регистрации приходит другая структура, без state.client!
            state.client = obj.client;
            if (state.client && !state.client.company) state.client.company = "";
        },
        client_address(state, obj) {
            // По заполнению формы регистрации приходит другая структура, без state.client!
            state.client = obj;
            if (state.client && !state.client.company) state.client.company = "";
        },
        locale(state, value) {
            I18n.locale = value
            state.locale = value
        },
        user_first_name(state, value) {
            state.first_name = value;
        },
        user_last_name(state, value) {
            state.last_name = value;
        },
        comm_prefs(state, blog, events, promotion) {
            state.settings.mail_blog = blog;
            state.settings.mail_events = events;
            state.settings.mail_promotion = promotion;
        },
        [SET_EMAILS](state, values) {
            state.emails = values
        },
        [DELETE_EMAIL](state, id) {
            state.emails = state.emails.filter(function (e) {
                return e.id != id;
            });
        },
        [SIGN_OUT](state) {
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
            if (isNotEmpty(sessionStorage.jwt)) Vue.http_delete(URL_SIGN_OUT, {}, false, false, false, true);

            const s = initialState()
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
            delete sessionStorage.jwt
            delete localStorage.jwt
            messages.clear()
        },
        // Вызывается после обновления токена из метода request, а так же в самом начале работы приложения
        // если prefetch-user.js нормально отработал. Здесь цель выполнить обновление токена через заданное
        // время.
        [LAST_TOKEN_UPDATE](state) {
            if (!isNotEmpty(sessionStorage.jwt)) return;

            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
            state.last_token_update = Date.now()
            //console.log(LAST_TOKEN_UPDATE, ': ' + state.last_token_update)
            this.timerId = setTimeout(
                function () {
                    Vue.post(URL_REFRESH_TOKEN)
                        .catch((e) => {
                            if (e.response.status == CODE_UNAUTHORIZED) {
                                handleUnauthorized();
                            }
                        })
                },
                SESSION_UPDATE_INTERVAL_MS)
        },
        [REMEMBER_ME](state) {
            state.sign_up_remember_me = true
        }
    },
    getters: {
        accessToken: () => {
            return sessionStorage.jwt
        },
        isComplete: state => () => {
            return state.id != initialState.id && isNotEmpty(sessionStorage.jwt);
        },
        isAdmin: (state, getters) => {
            if (!getters.isComplete()) return false;
            let r = state.roles;
            return r &&
                ((r.indexOf("admin") > -1) ||
                    (r.indexOf("root") > -1))
        },
        name: state => {
            if (!state.first_name) return '[None]';
            let r = state.first_name
            if (r) {
                if (state.last_name) {
                    r += ' ' + state.last_name
                }
            } else {
                r = state.last_name
            }
            return r;
        },
        unverifiedEmail: state => {
            return state.emails.find(e => !e.verified);
        }
    },
    actions: {
        [SET_LOCALE](context, value) {
            if (context.getters.isComplete()) {
                Vue.post(URL_SET_USER_LOCALE, { locale: value })
                    .then(() => {
                        context.commit('locale', value);
                        context.dispatch(LOAD_COUNTRIES);
                    })
                    .catch((e) => {
                        alert.show(e);
                    })
            } else {
                // Сохраним вручную выбранную локаль временно, для следующего захода на страницу
                localStorage._offline_locale = value
                context.commit('locale', value);
                context.dispatch(LOAD_COUNTRIES);
            }
        },
        // На входе экземпляр EncodableUserWithClient
        [SETUP_FROM_DATA](context, payload) {
            const obj = (typeof payload === 'object') ? payload : JSON.parse(payload);

            context.commit('simple_props', obj);
            context.commit('locale', obj.settings.locale);
        },
        // На входе экземпляр EncodableClient
        [UPDATE_CLIENT_DATA](context, payload) {
            const obj = (typeof payload === 'object') ? payload : JSON.parse(payload);
            context.commit('client_address', obj);
        },
        init(context) {
            context.commit('locale', context.state.locale);
        }
    }
}

export default user;